import ModalTransition from '@atlaskit/modal-dialog/modal-transition';

import { CarouselBaseCard } from '@post-office/browser--growth-starburst/common/carouselBaseCard';

import {
	type CardImages,
	type CarouselCardProps,
} from '@post-office/browser--growth-starburst/common/carouselBaseCard/types';

import { commonTwcMessages } from '@post-office/browser--growth-starburst/common/constants';

import { useState } from 'react';

import { defineMessages } from 'react-intl';

import { VideoModal } from './VideoModal';

import { TWCCardIllustrationDark } from '../assets/TWCCardIllustrationDark';

import { TWCCardIllustrationLight } from '../assets/TWCCardIllustrationLight';

import { type JSX } from 'react/jsx-runtime';

enum VideoState {
	NOT_WATCHED = 0,
	WATCHING = 1,
	FINISHED = 2,
}

export const TwcGettingStartedCard = (props: CarouselCardProps): JSX.Element => {
	const [videoState, setVideoState] = useState(VideoState.NOT_WATCHED);

	/**
	 * We deliberately don't want to pass all the props here because we manually control some of them.
	 * Do not pass `displayUrl` to the underlying card
	 */
	const { displayUrl: _, onClick, variant, ...remainingProps } = props;
	const images: CardImages = {
		component: <TWCCardIllustrationLight />,
		componentDark: <TWCCardIllustrationDark />,
	};

	const onVideoOpen = () => {
		setVideoState(VideoState.WATCHING);
	};
	const onVideoClose = () => {
		onClick && onClick();
		setVideoState(VideoState.FINISHED);
	};

	// Early mark the card as completed when user has watched the video
	const variantToUse = videoState === VideoState.FINISHED ? 'completed' : variant;
	return (
		<>
			<CarouselBaseCard
				{...remainingProps}
				messages={{ ...gettingStartedMessages, ...commonTwcMessages }}
				images={images}
				onClick={onVideoOpen}
				variant={variantToUse}
				enableCompletedOnClick={false}
			/>
			<ModalTransition>
				{videoState === VideoState.WATCHING && <VideoModal onClose={onVideoClose} />}
			</ModalTransition>
		</>
	);
};

const gettingStartedMessages = defineMessages({
	heading: {
		defaultMessage: 'See how it all works together',
		description: 'Heading for the twc onboarding card',
		id: 'townsquare.twc-onboarding-widget.twc-card.heading',
	},
	description: {
		defaultMessage: 'Not sure where to start? Find out how your apps can streamline your work.',
		description: 'Description for the twc onboarding card',
		id: 'townsquare.twc-onboarding-widget.twc-card.description',
	},
	cta: {
		defaultMessage: 'Watch video',
		description: 'CTA text for the twc onboarding card',
		id: 'townsquare.twc-onboarding-widget.twc-card.cta',
	},
});
